import LanguageEdit from './LanguageEdit'

export default LanguageEdit
